<template>
  <section>
    
    <h1 class="section-head">รายละเอียดซัพพลายเออร์: {{ supplier.name }} </h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" to="/supplier"><i class="fas fa-arrow-left"></i>กลับ</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-info is-pulled-right" :to="('/purchaseorder/add/'+this.$route.params.id)" v-can="'add_po'"><i class="fas fa-clipboard-list"></i>สั่งสินค้าจากซัพพลายเออร์</router-link>
          </div>
        </div>
      </div>
    </nav>

    <div class="content">
      <h3 class="header-line"><strong>{{supplier.name}}</strong> <router-link class="button is-warning is-small" :to="('/supplier/edit/'+this.$route.params.id)"><i class="fas fa-pencil-alt"></i>แก้ไข</router-link></h3>
    </div>

    <div class="columns">
      <div class="column">

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ชื่อผู้ติดต่อ</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="ชื่อผู้ติดต่อ" v-model="this.supplier.attention" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ที่อยู่</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="ที่อยู่" v-model="this.supplier.address" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-map-marker-alt"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">เบอร์โทรศัพท์</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="เบอร์โทรศัพท์" v-model="this.supplier.phone" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-phone"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">เลขผู้เสียภาษี</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="เลขผู้เสียภาษี" v-model="this.supplier.tax_no" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
          
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">E-Mail</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="E-Mail" v-model="this.supplier.email" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">บัญชีธนาคาร</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="บัญชีธนาคาร" v-model="this.supplier.bank_name" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-university"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ชื่อบัญชี</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="ชื่อบัญชี" v-model="this.supplier.bank_account_name" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
          
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">เลขที่บัญชี</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="เลขที่บัญชี" v-model="this.supplier.bank_account_no" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-piggy-bank"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-product-list :supId="this.$route.params.id"></app-product-list>
    <h1 class="section-head">รายการสั่งซื้อของ {{ supplier.name }} </h1>
    <app-purchaseorder :supId="this.$route.params.id"></app-purchaseorder>
  </section>
</template>

<script>
  import Request from '@/libraries/request';
  import Product_list from '@/components/Product_list';
  import Purchase_order from '@/components/purchase_order';
  import SupplierModel from '@/model/supplier_model';

  export default {
    name: "Supplier_add",
    components: {
      'app-product-list': Product_list,
      'app-purchaseorder': Purchase_order
    },
    data() {
      return {
        supplier: {
          name: "",
          address: "",
          phone: "",
          email: "",
          tax_no: ""
        },
        isLoading: true
      }
    },
    created() {
      this.get_supplier();
    },
    methods: {
      async get_supplier() {
        if(this.$route.params.id == 'undefined'){
          this.$buefy.snackbar.open('Supplier ID not found.');
          this.$router.push('/supplier');
        }else{
          try{
            const supplier = await SupplierModel.get_supplier(this.$route.params.id);
            this.supplier = supplier;
            this.isLoading = false;
          }catch(e){
            this.$buefy.snackbar.open(e.message);
            this.$router.push('/supplier');
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.header-line {
  border-bottom: 1px solid #C7C7C7;
  padding-bottom: 0.25rem;
}
</style>




// WEBPACK FOOTER //
// src/pages/Supplier/view.vue